import PropTypes from "prop-types";
import { Card, Typography, LinearProgress, Box, useTheme } from "@mui/material";
import StoreIcon from "../common/StoreIcon";

CustomProgressBarSummary.propTypes = {
  color: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      pct: PropTypes.number.isRequired,
      store: PropTypes.number.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  sx: PropTypes.object,
  ItemComponent: PropTypes.elementType,
};

export default function CustomProgressBarSummary({
  title,
  total,
  sx,
  data,
  color = "primary",
  ItemComponent,
  ...other
}) {
  const theme = useTheme();

  // Default component if none provided
  const DefaultItemComponent = ({ item }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <StoreIcon store={item.store} />
      <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
        {item.title}
      </Typography>
    </Box>
  );

  const ItemRenderer = ItemComponent || DefaultItemComponent;
  return (
    <Card
      sx={{
        py: 1,
        px: 3,
        boxShadow: 0,
        textAlign: "left",
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h5">
        {title}
      </Typography>
      <Box sx={{ mt: 2 }}>
        {data.map((item, index) => (
          <Box key={index} sx={{ mb: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
              <ItemRenderer item={item} />
              <Typography variant="body2" sx={{ fontSize: "1rem", fontWeight: 500 }}>
                {item.amount}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={item.pct}
              sx={{
                height: 10,
                backgroundColor: theme.palette.action.hover,
                borderRadius: 2,
                "& .MuiLinearProgress-bar": {
                  backgroundColor: theme.palette[color].main,
                  borderRadius: 2,
                },
              }}
            />
          </Box>
        ))}
      </Box>

    </Card>
  );
}
